/**
 * @generated SignedSource<<341ba977a22fe8ce5f0b424dc49f2708>>
 * @relayHash b761690351fd38a63053eefb2d1de3c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8983e89338e9db4549f597c6a2f7f4aa36777c139be8c74459f3b001a0c76de2

import type { ConcreteRequest } from 'relay-runtime';
export type SmartCreateFeedbackBannerQuery$variables = {
  contentId: string;
};
export type SmartCreateFeedbackBannerQuery$data = {
  readonly singleContent: {
    readonly contentProperties: {
      readonly draft: {
        readonly generatedBy: string | null;
      } | null;
      readonly latest: {
        readonly generatedBy: string | null;
      } | null;
    } | null;
    readonly creatorId: string | null;
    readonly history: {
      readonly createdDate: string | null;
    } | null;
    readonly id: string | null;
    readonly title: string | null;
    readonly type: string | null;
    readonly version: {
      readonly number: number | null;
    } | null;
  } | null;
};
export type SmartCreateFeedbackBannerQuery = {
  response: SmartCreateFeedbackBannerQuery$data;
  variables: SmartCreateFeedbackBannerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "generatedBy"
  }
],
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "title"
      },
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "kind": "ScalarField",
        "name": "creatorId"
      },
      {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "number"
          }
        ]
      },
      {
        "concreteType": "History",
        "kind": "LinkedField",
        "name": "history",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "createdDate"
          }
        ]
      },
      {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
          {
            "concreteType": "DraftContentProperties",
            "kind": "LinkedField",
            "name": "draft",
            "plural": false,
            "selections": (v1/*: any*/)
          },
          {
            "concreteType": "PublishedContentProperties",
            "kind": "LinkedField",
            "name": "latest",
            "plural": false,
            "selections": (v1/*: any*/)
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SmartCreateFeedbackBannerQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SmartCreateFeedbackBannerQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "b761690351fd38a63053eefb2d1de3c0",
    "id": "8983e89338e9db4549f597c6a2f7f4aa36777c139be8c74459f3b001a0c76de2",
    "metadata": {},
    "name": "SmartCreateFeedbackBannerQuery",
    "operationKind": "query",
    "text": "query SmartCreateFeedbackBannerQuery($contentId:ID!){singleContent(id:$contentId){title,id,type,creatorId,version{number},history{createdDate},contentProperties{draft{generatedBy},latest{generatedBy}}}}"
  }
};
})();

(node as any).hash = "da911efda658d22b5292ee38ba4e3f5f";

export default node;
